import React from "react";
import { Building } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

const DepartmentManagement = () => (
  <SettingsListPanel
    config={{
      title: "Department Management",
      subtitle: "Manage organization departments and teams",
      icon: Building,
      endpoint: "/api/settings/departments",
      itemLabel: "Department",
      columnLabel: "Department Name",
      placeholder: "Enter department name...",
    }}
  />
);

export default DepartmentManagement;
